import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Users, Ruler, Send, ArrowRight } from "lucide-react";

const SLIDES = [
  {
    icon: Users,
    title: "Tous vos clients, à vie",
    text: "Enregistrez chaque client une seule fois, avec son nom, ses photos et ses tissus.",
  },
  {
    icon: Ruler,
    title: "Les mesures en 2 secondes",
    text: "Quand un client rappelle, retrouvez ses mesures et son tissu instantanément — même hors ligne.",
  },
  {
    icon: Send,
    title: "Partagez sur WhatsApp",
    text: "Envoyez les mesures d'un client sur WhatsApp en un seul clic, joliment formatées.",
  },
];

export default function Onboarding() {
  const navigate = useNavigate();
  const [i, setI] = useState(0);
  const Slide = SLIDES[i];
  const Icon = Slide.icon;

  const finish = () => {
    localStorage.setItem("tp_onboarded", "1");
    navigate("/");
  };
  const next = () => (i < SLIDES.length - 1 ? setI(i + 1) : finish());

  return (
    <div className="min-h-screen bg-tp-green text-white flex flex-col px-6 py-10">
      <div className="flex justify-end">
        <button data-testid="onboarding-skip" onClick={finish} className="text-white/70 font-semibold py-2">
          Passer
        </button>
      </div>
      <motion.div
        key={i}
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.25 }}
        className="flex-1 flex flex-col items-center justify-center text-center"
      >
        <div className="w-24 h-24 rounded-3xl bg-tp-gold flex items-center justify-center mb-8">
          <Icon size={44} className="text-tp-ink" />
        </div>
        <h1 className="font-head text-3xl font-extrabold mb-4">{Slide.title}</h1>
        <p className="text-white/80 text-lg leading-relaxed max-w-xs">{Slide.text}</p>
      </motion.div>

      <div className="flex items-center justify-center gap-2 mb-8">
        {SLIDES.map((_, idx) => (
          <div key={idx} className={`h-2 rounded-full transition-all ${idx === i ? "w-7 bg-tp-gold" : "w-2 bg-white/30"}`} />
        ))}
      </div>
      <Button
        data-testid="onboarding-next"
        onClick={next}
        className="w-full h-[54px] rounded-full bg-tp-gold hover:bg-tp-gold/90 text-tp-ink text-base font-bold"
      >
        {i < SLIDES.length - 1 ? "Suivant" : "Commencer"} <ArrowRight size={20} />
      </Button>
    </div>
  );
}
